export const openTab = (url: string, target = '_blank', isSponsored = false): void => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.target = target;
  if (isSponsored) {
    link.setAttribute('data-google-interstitial', 'false');
  }
  setTimeout(() => {
    link.click();
  });
}

